module.exports = __webpack_public_path__ + "static/media/delete-icon.455c3d73.svg";